import { api, formHeaders } from "@";

// Fetches the admin popup screen data with pagination
export const getAdminPopupScreen = () =>
  api.get(`/api/AdminPopupScreen?Page=1&PageSize=`);

// Toggles the active status of a popup screen by ID
export const toggleActive = (id, value) =>
  api.put(`/api/AdminPopupScreen/change-status/${id}?status=${value}`);

// Saves a new or existing admin popup screen
export const saveAdminPopupScreen = (data) => {
  const payload = {
    Url: data.url,
    Image: data.image,
    Section: data.section,
    IsActive: data.isActive,
  };
  if (data.id) {
    return api.put(`/api/AdminPopupScreen/${data.id}`, payload, formHeaders);
  }
  return api.post(`/api/AdminPopupScreen`, payload, formHeaders);
};
